import * as React from 'react'

import type { LazyComponentProps, LazyLoader, LazyOptions, Loader } from './lazy.types'

/**
 * Lazyload implementation for component.
 *
 * @todo add Error Boundary
 */
export default function lazyload<P = {}>(loader: Loader<P>, options?: LazyOptions): React.ComponentType<P> {
  // invoke lazy import from loader
  const Component = React.lazy(loader as LazyLoader<P>)

  const LazyComponent = (props: LazyComponentProps<P>) => (
    <React.Suspense fallback={getFallbackComponent(options)}>
      <Component {...props} />
    </React.Suspense>
  )

  return LazyComponent as React.ComponentType<P>
}

/**
 * Render fallback component based on given options
 */
function getFallbackComponent(options?: LazyOptions) {
  if (options) {
    const { loading: Loading } = options

    if (Loading) {
      return <Loading />
    }
  }

  return null
}
